import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { CrawfordGridComponent, DateFormat, GridColumn, NumberFormat, CrawfordApiGridAdaptor, ApiGridParameters,
  ITabComponent, CrawfordSnackbarService, CrawfordSpinnerService } from 'crawford-shell';
import { DataManager } from '@syncfusion/ej2-data';
import { global } from '../../app.settings';
import { PageSettingsModel } from '@syncfusion/ej2-grids';
import { ClaimService } from '../claim.service';

@Component({
  selector: 'app-claim-adjuster-fees',
  templateUrl: './claim-adjuster-fees.component.html',
  styleUrls: ['./claim-adjuster-fees.component.scss']
})
export class ClaimAdjusterFeesComponent implements OnInit, ITabComponent {

  @Input() public crawfordRef: string;
  @Input() public source: string;

  @ViewChild('ccogrid') public ccoGrid: CrawfordGridComponent;

  public adaptor: CrawfordApiGridAdaptor;
  public dataSource: DataManager;
  public showGrid: boolean;

  sortingSettings: any = {
    columns: [{ field: 'date', direction: 'descending' }]
  };

  dateFormat: DateFormat = {
    type: 'date',
    format: global.dateFormat
  };

  currencyFormat: NumberFormat = {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    currency: 'gbp',
    format: '£#,#.##'
  };

  displayColumns: GridColumn[] = [
    new GridColumn('adjusterName', 'Adjuster'),
    new GridColumn('date', 'Date', { type: 'date', format: this.dateFormat }),
    new GridColumn('value', 'Value', {type: 'number', format: this.currencyFormat })
  ];

  pageSettings: PageSettingsModel = {
    pageSize: 8
  };

  constructor(
    private claimService: ClaimService,
    private spinnerService: CrawfordSpinnerService,
    private snackbarService: CrawfordSnackbarService
  ) { }

  ngOnInit() {
  }

  loadData(): void {
    this.spinnerService.show('claimAdjusterFeesSpinner');
    this.showGrid = false;
    this.adaptor = this.initializeAdaptor();
    this.dataSource = this.claimService.getClaimAdjusterFeesDataManager(this.crawfordRef, this.adaptor);
  }

  private initializeAdaptor(): CrawfordApiGridAdaptor {
    const parameters = new ApiGridParameters();
    parameters.additional = { claimDataSource: this.source };
    parameters.top = this.pageSettings.pageSize;
    parameters.orderBy.columnName = this.sortingSettings.columns[0].field;
    parameters.orderBy.direction = this.sortingSettings.columns[0].direction;

    return new CrawfordApiGridAdaptor(parameters);
  }

  onDataBound($event: any): void {
    this.spinnerService.hide('claimAdjusterFeesSpinner');
  }

  onActionFailure($event): void {
    this.snackbarService.displayErrorMessage($event.error);
    this.spinnerService.hide('claimAssociatedClaimsSpinner');
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/UI/src/app/claim/claim-adjuster-fees/claim-adjuster-fees.component.ts